import styled from 'styled-components';
import { DEVICES } from '_constants';

export const ModalWrapper = styled.div`
  position: relative;
  /* The Modal renders with autoWidth (sizes to content), so pin a static width on big screens —
     otherwise the new-UI table (width:100%) expands the modal to fill the viewport. */
  width: 900px;
  max-width: calc(100vw - 40px);
  height: 80vh;
  overflow: auto;
  font-size: 14px;
  padding: 40px;

  @media ${DEVICES.tablet} {
    width: auto;
    max-width: 100vw;
    padding: 0;
  }

  .react-table__wrapper {
    @media ${DEVICES.tablet} {
      * {
        font-size: 8.2px;
      }
      .rt-td {
        padding: 4px 10px !important;
      }
      input {
        height: 14px;
        width: 14px;

        :after {
          left: -1px;
          top: 1px;
        }
      }
    }
  }
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-flow: row nowrap;
  margin-bottom: 15px;

  button:not(:last-child) {
    margin-right: 10px;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-directions: column;
  margin: 20px 0;

  .Add-button {
    margin-right: 10px;
  }

  @media ${DEVICES.tablet} {
    .Add-button {
      padding: 0;
      min-width: 80px;
    }
  }
`;
